import init from '../../../js/init';
import { getURLParams, setURLParams } from '../../../js/utils';

const name = 'airline-routes';
const selector = '.airline-routes';
const mapSelector = `${selector}__map .route-map`;
const buttonSelector = `${selector}__buttons ${selector}__button img`;

init(Drupal, name, selector, root => {
  const airlines = JSON.parse(root.getAttribute('data-airlines'));
  const cities = JSON.parse(root.getAttribute('data-cities'));

  const mapElem = root.querySelector(mapSelector);
  const buttons = root.querySelectorAll(buttonSelector);
  let currentCountry = '';

  const changeDestinations = (destinations, do_zoom) => {
    const event = new CustomEvent('change-destinations', {
      bubbles: true,
      detail: { destinations, do_zoom },
    });
    mapElem.dispatchEvent(event);
  };

  const resetDestinations = (destinations, do_zoom) => {
    const event = new CustomEvent('reset-destinations', {
      bubbles: true,
      detail: { destinations, do_zoom },
    });
    mapElem.dispatchEvent(event);
  };

  const setButtonStyle = selected_button => {
    buttons.forEach(button => {
      button.classList.remove('border-2', 'border-secondary-90');
      button.classList.add('border', 'border-gray-70');
    });
    selected_button.classList.add('border-2', 'border-secondary-90');
    selected_button.classList.remove('border', 'border-gray-70');
  };

  const airlineChanged = airline_elem => {
    const airline = airlines.find(a => a.name === airline_elem.dataset.name);
    let destinations = [];
    let do_zoom = false;
    if (airline.name === 'all') {
      destinations = airlines
        .filter(a => a.name !== 'all')
        .reduce(
          (prev, current) => [
            ...prev,
            ...Object.keys(current.destinations).map(d => ({
              name: d + ' (' + current.destinations[d] + ')',
              destination: cities[d].city,
              airline: current.label,
            })),
          ],
          []
        );
      resetButtons();
      resetDestinations(destinations, true);
    } else {
      destinations = Object.keys(airline.destinations).map(d => ({
        name: d + ' (' + airline.destinations[d] + ')',
        destination: cities[d].city,
        airline: airline.label,
      }));
      do_zoom = true
      if (currentCountry !== '') {
        destinations = destinations.filter(d => (currentCountry !== '' ? d.name.indexOf(', ' + currentCountry.toLowerCase()) !== -1 : true));
      }
    }

    setURLParams({ airline: airline.name });

    changeDestinations(destinations, do_zoom);

    setButtonStyle(airline_elem)
  };

  buttons.forEach(button => {
    button.onclick = e => {
      airlineChanged(e.target);
    };
  });

  const filterValues = getURLParams();
  let default_selected_button = root.querySelector(`${selector}__buttons ${selector}__button [data-name="all"]`);

  setTimeout(() => {
    airlineChanged(default_selected_button);
    if (filterValues && filterValues.airline) {
      default_selected_button = root.querySelector(`${selector}__buttons ${selector}__button [data-name="` + filterValues.airline + `"]`);
      setTimeout(() => {
        airlineChanged(default_selected_button);
      }, 1);
    }
  }, 1);



  root.addEventListener('change-country', e => {
    const { country } = e.detail;
    currentCountry = country;
    buttons.forEach((button) => {
      const button_id = button.dataset.name.toString();
      const airline = airlines.reduce((accumulator, currentValue) => (currentValue.name.toString() === button_id ? currentValue : accumulator), null);
      if (airline && !Object.keys(airline.destinations).filter((destination) => (destination.includes(', ' + country.toLowerCase()))).length) {
        button.classList.add('greyscale');
        button.classList.add('opacity-20');
        button.parentElement.classList.add('bg-gray');
        button.parentElement.classList.add('cursor-auto');
      }
    });
  });

  const resetButtons = (ev) => {
    currentCountry = '';
    buttons.forEach((button) => {
      button.classList.remove('grayscale');
      button.classList.remove('opacity-20');
      button.classList.remove('border-2');
      button.classList.remove('border-secondary-90');
      button.classList.add('border');
      button.classList.add('border-gray-70');
      button.parentElement.classList.remove('bg-gray');
      button.parentElement.classList.remove('cursor-auto');
    });
  }

  root.addEventListener('map-reset', e => {resetButtons();});
});
